import { motion } from "framer-motion";
import classNames from "classnames";

export const Statement = ({ onAnswer, isTransitioning, direction }) => {
    return (
        <motion.div
            className={classNames("px-4 h-full flex flex-col justify-center", {
                "pointer-events-none": isTransitioning,
            })}
            initial={{ opacity: 0, x: direction === "back" ? -20 : 20 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: direction === "back" ? 20 : -20 }}
            transition={{ duration: 0.3 }}>
            <div className="flex flex-col items-center text-center gap-8 max-w-md mx-auto">
                <div className="flex gap-2 text-4xl">
                    {["🛡️", "💪", "❤️"].map((emoji, i) => (
                        <span key={i} className="animate-bounce" style={{ animationDelay: `${i * 0.1}s` }}>
                            {emoji}
                        </span>
                    ))}
                </div>
                <h1 className="text-2xl font-bold">Our Commitment to You</h1>
                <p className="text-gray-600">
                    While we strive for perfection, we believe in being transparent. Mistakes can happen, but our commitment to your safety is unwavering. We continuously work with our community and experts to identify and correct any inaccuracies quickly.
                </p>
                <button
                    onClick={() => onAnswer({ text: "Continue" })}
                    className="bg-primary text-white rounded-full px-8 py-3 font-medium hover:bg-primary-dark transition-colors">
                    Continue
                </button>
            </div>
        </motion.div>
    );
}; 